import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import '@fontsource/merriweather/400.css';
import '@fontsource/merriweather/900.css';
import StickyCard from '@components/Blogs/StickyCard';
import useAuth from '@hooks/useAuth';

/**
 *
 * @param {Object} props - Blog content
 * @param {string} props.blogContent - Blog content
 * @returns JSX.Element
 */
function BlogBody({ blogContent }) {
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const { isUserLoggedIn } = useAuth();

  useEffect(() => {
    if (!isUserLoggedIn()) {
      if (window.screen.width > 1240 || window.screen.width < 730) {
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        setIsCardVisible(true);
      }
    } else {
      setIsClosed(true);
      setIsCardVisible(false);
    }
  }, []);

  const onScroll = () => {
    const blogContent = document.querySelector('.blog-content');
    if (
      window.scrollY > (blogContent.offsetHeight * 5) / 100 &&
      window.scrollY < document.body.offsetHeight - 2000
    ) {
      setIsCardVisible(true);
    }
    if (window.scrollY > document.body.offsetHeight - 2000) {
      setIsCardVisible(false);
    }
  };

  const closeStickyCard = () => {
    setIsCardVisible(false);
    setIsClosed(true);
  };
  return (
    <>
      {!isClosed && (
        <StickyCard isVisible={isCardVisible} onClose={closeStickyCard} />
      )}
      <BlogWrapper
        className="blog-content px-4 lg:px-0"
        dangerouslySetInnerHTML={{
          __html: blogContent,
        }}
      />
    </>
  );
}

export default BlogBody;

BlogBody.propTypes = {
  blogContent: PropTypes.string.isRequired,
};

const BlogWrapper = styled.section`
  max-width: 800px;
  margin: 1rem auto;

  p {
    line-height: 1.85;
    font-family: 'Merriweather', Inter, -apple-system, sans-serif;
    color: #333333;
    font-size: 15px;
    margin-bottom: 1rem;
  }

  .aligncenter {
    margin: 0 auto;
  }

  .wp-caption {
    max-width: 100%;
    margin-bottom: 30px !important;
    padding: 0;
    background: 0 0;
    color: #000;
    font-style: italic;
  }

  .wp-caption p.wp-caption-text {
    font-style: normal;
    letter-spacing: -0.03em;
    font-weight: 300 !important;
    font-size: 14px !important;
    color: #888;
    line-height: 17px;
    margin: 8px 0 0;
    text-align: center;
  }

  .wp-block-image {
    margin-top: calc(40px + 0.25vw);
    margin-bottom: calc(40px + 0.25vw);
  }

  img {
    margin: 2rem auto 0;
    border-radius: 10px;
  }

  iframe {
    margin: 1rem auto;
  }

  table {
    margin: 1.5rem auto;
    width: 100%;

    td > p {
      color: #111111;
    }
    tr {
      border: 1px dashed #a7a7a7;
    }
  }
  a {
    color: rgb(16, 93, 247) !important;

    span {
      color: rgb(16, 93, 247) !important;
    }

    &:hover {
      color: #111111;
    }
  }

  ol,
  ul {
    padding: 0 1rem;
    padding-left: 2.5rem;
  }
  ul,
  li {
    list-style: disc;
  }
  li {
    margin-bottom: 20px;
    font-family: 'Merriweather', Inter, -apple-system, sans-serif;
  }
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    margin-top: 2rem;
    margin-bottom: 0.5rem;
    line-height: 1.3;
  }

  h1 {
    font-size: 40px;
  }
  h2 {
    font-size: 32px;
  }
  h3 {
    font-size: 28px;
  }
  h4 {
    font-size: 24px;
  }
  h5 {
    font-size: 20px;
  }
  h6 {
    font-size: 16px;
  }

  > span {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    iframe {
      width: 100%;
    }
  }
`;
